import { writable } from 'svelte/store';
export const SIZES = ["minimize", "maximize"];
let state = {
    logo: "",
    page_message: "",
    jumbotron: "",
    tool_tip_message: "",
    button_message: "",
    contacts: "",
    call_line: "",
    secondary_text_color: "",
    primary_text_color: "",
    bottom_position: 0,
    right_position: 0,
    primary_bg_color: "",
    secondary_bg_color: "",
    is_active: true,
    size: SIZES[0],
    id: 0,
    business_name: "",
    archived: null,
    last_modified: "",
    date_created: "",
    business: null,
    business_number: "",
    widget_type: ''
};
let widget = () => {
    const { subscribe, set, update } = writable(state);
    return {
        subscribe,
        set: (data) => {
            return update((store) => (Object.assign(Object.assign({}, store), data)));
        },
        toggleSize: () => {
            return update((store) => {
                const { size: currentSize } = store;
                const size = SIZES[(SIZES.indexOf(currentSize) + 1) % SIZES.length];
                return Object.assign(Object.assign({}, store), { size });
            });
        },
        minimize: () => {
            return update((store) => (Object.assign(Object.assign({}, store), { size: SIZES[1] })));
        },
        maximize: () => {
            return update((store) => (Object.assign(Object.assign({}, store), { size: SIZES[0] })));
        }
    };
};
export default widget();
